module.exports = __webpack_public_path__ + "img/gabon.944c5757.svg";